export default function announcementBar() {
    function setCookie(cname, cvalue, exdays) {
        var expires = "expires=0";
        if (exdays !== 0) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            expires = "expires=" + d.toUTCString();
        }
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function hideAnnouncement() {
        var hideAnnouncement = getCookie("hideAnnouncement");
        if (hideAnnouncement === "true") {
            $('.announcement').addClass('d-none');
        } else {
            $('.announcement').removeClass('d-none');
        }
    }

    $('.announcement-close').on('click', function (e) {
        e.preventDefault();
        setCookie('hideAnnouncement', "true", 7);
        $('.announcement').addClass('d-none');
    });

    hideAnnouncement();
}
